var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSizeIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 10.0002L14.6667 5.8335M14.6667 5.8335H11.5417M14.6667 5.8335V8.9585",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 9.99984L6.33333 14.1665M6.33333 14.1665H9.45833M6.33333 14.1665V11.0415",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.16675 9.99984C2.16675 6.07147 2.16675 4.10728 3.38714 2.88689C4.60752 1.6665 6.57171 1.6665 10.5001 1.6665C14.4285 1.6665 16.3926 1.6665 17.613 2.88689C18.8334 4.10728 18.8334 6.07147 18.8334 9.99984C18.8334 13.9282 18.8334 15.8924 17.613 17.1128C16.3926 18.3332 14.4285 18.3332 10.5001 18.3332C6.57171 18.3332 4.60752 18.3332 3.38714 17.1128C2.16675 15.8924 2.16675 13.9282 2.16675 9.99984Z",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSizeIcon);
export default __webpack_public_path__ + "static/media/SizeIcon.1d0b8b64727b3976fbfef5c4bfebfa80.svg";
export { ForwardRef as ReactComponent };